import React from "react";
import { connect } from "react-redux";
import { MusicInstrumentContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import { MdAssignmentAdd } from "react-icons/md";
import moment from "moment";
import momentTZ from "moment-timezone";
import * as XLSX from "xlsx";
import queryString from "query-string";
import { INSTUMENT_TYPE_OPTIONS } from "utils/functions/productBooking";
import { Inputs, Displays, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class MusicInstrumentContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
    instrumentTypeSelected: null,
  };

  componentDidMount() {
    const { perPage } = this.state;
    scrollToTopPageFN();
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_INSTRUMENT_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
          total: res.data.totalDocs,
          per_page: res.data.limit,
        },
      });
    }
  };

  handleFilterKeyword = (e) => {
    const queryParams = queryString.parse(e);
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
      instrumentTypeSelected: queryParams.instrument_type_code,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoading: true,
    });
    this.props.router.navigate(`${ROUTE_PATH.MUSIC_INSTRUMENT}${joinQuery}`);
    this.fetchData(joinQuery);
  };

  handleClickEdit = (e) => {
    this.props.router.navigate(
      `${ROUTE_PATH.MUSIC_INSTRUMENT}/${e}?onEdit=true`
    );
  };

  handleClickView = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.MUSIC_INSTRUMENT}/${e}`);
  };

  handleExport = async () => {
    const { filterQuery } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false`
      : `?pagination=false`;

    let res = await portalService.GET_INSTRUMENT_LIST(joinQuery);
    if (res && res.status === 200) {
      let wb = XLSX.utils.book_new();
      let ws_name = "Music Instruments";

      const ws_data = [
        [
          "No",
          "Create Date",
          "ประเภทเครื่องดนตรี",
          "กลุ่มสินค้า",
          "Brand",
          "Model",
          "Series",
          "Serial No.",
          "Owner Name",
          "Phone Number",
        ],
      ];

      res.data.docs.forEach((e, i) => {
        ws_data.push([
          i + 1,
          momentTZ(e.created_at).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm"),
          e.instrument_type_th || "-",
          e.product_th || "-",
          e.brand || "-",
          e.model || "-",
          e.series || "-",
          e.serial_no || "-",
          e.customer_first_name || "-",
          e.customer_phone_number || "-",
        ]);
      });

      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      ws["!cols"] = [
        { wch: 5 },
        { wch: 18 },
        { wch: 20 },
        { wch: 20 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
      ];

      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `music-instrument-report-${moment()
          .tz("Asia/Bangkok")
          .format("YYYY-MM-DD")}.xlsx`
      );
      this.setState({ isBgLoading: false });
    }
  };

  handleCheckCode = () => {
    this.props.router.navigate(`${ROUTE_PATH.REWARD_CHECK_CODE}`);
  };

  render() {
    const { authenRedux, router } = this.props;
    const { isLoading, isBgLoading, pagination, data } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "instrument");

    return (
      <MusicInstrumentContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />

        <Inputs.InputFilter
          theme_standard_input_filter
          dataFilter={dataFilter(
            router.location?.search,
            this.state.instrumentTypeSelected
          )}
          btnLabel="ค้นหา"
          onQueryFilter={this.handleFilterKeyword}
          onExport={
            permission &&
            (permission.is_export || permission.is_export_condition)
              ? () => this.handleExport(permission)
              : false
          }
        />
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="324px" />
        ) : (
          <>
            <div className="body_table  ">
              <Tables.Standard
                columns={columns({
                  handleClickView: this.handleClickView,
                  handleClickEdit: this.handleClickEdit,
                })}
                data={data}
                showPagination
                pagination={pagination}
                handlePageClick={this.handlePageClick}
                onChangePerPage={this.handlePerPageChange}
              />
            </div>
          </>
        )}
      </MusicInstrumentContainerStyled>
    );
  }
}

const dataFilter = (query, instrumentTypeSelected) => {
  let initialValues = queryString.parse(query);

  return [
    {
      accessor: "instrument_type_code",
      length: "311px",
      filter: {
        fieldQuery: "instrument_type_code",
        defaultValue:
          initialValues["instrument_type_code"] || instrumentTypeSelected,
        type: "dropdown",
        label: "ประเภทเครื่องดนตรี",
        placeholder: "All",
        options: INSTUMENT_TYPE_OPTIONS.map((e) => ({
          label: e.labelTh,
          value: e.value,
        })),
      },
    },
    // {
    //   accessor: "product_code",
    //   length: "311px",
    //   filter: {
    //     fieldQuery: "product_code",
    //     defaultValue: initialValues["product_code"],
    //     type: "dropdown",
    //     label: "กลุ่มสินค้า",
    //     placeholder: "All",
    //     options: CATE_PRODUCT_OPTION_OBJECT_CASE(instrumentTypeSelected).map(
    //       (e) => ({
    //         label: e.labelTh,
    //         value: e.value,
    //       })
    //     ),
    //   },
    // },
    {
      accessor: "name",
      length: "311px",
      filter: {
        fieldQuery: "name",
        defaultValue: initialValues["name"],
        type: "text",
        label: "Product owner Name",
        placeholder: "",
      },
    },
    {
      accessor: "phone_number",
      length: "311px",
      filter: {
        fieldQuery: "phone_number",
        defaultValue: initialValues["phone_number"],
        type: "text",
        label: "Product owner phone number",
        placeholder: "",
      },
    },
  ];
};

const columns = ({ handleClickView, handleClickEdit }) => [
  {
    Header: <div style={{ textAlign: "left" }}>Create Date</div>,
    accessor: "created_at",
    Cell: (props) =>
      momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm"),
  },
  {
    Header: <div style={{ textAlign: "left" }}>ประเภทเครื่องดนตรี</div>,
    accessor: "instrument_type_th",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>กลุ่มสินค้า</div>,
    accessor: "product_th",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Brand</div>,
    accessor: "brand",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Model</div>,
    accessor: "model",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Series</div>,
    accessor: "series",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Serial No.</div>,
    accessor: "serial_no",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Owner Name</div>,
    accessor: "customer_first_name",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "center" }}>Phone Number</div>,
    accessor: "customer_phone_number",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "center" }}>View</div>,
    accessor: "view",
    Cell: (props) => (
      <div
        style={{ textAlign: "center" }}
        onClick={() => handleClickView(props.row.original._id)}
      >
        <MdAssignmentAdd size={22} color="#75D317" />
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "center" }}>Edit</div>,
    accessor: "edit",
    Cell: (props) => (
      <div
        style={{ textAlign: "center" }}
        onClick={() => handleClickEdit(props.row.original._id)}
      >
        <MdAssignmentAdd size={22} color="#F89900" />
      </div>
    ),
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MusicInstrumentContainer));
